import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

import { useEstateDetail, useSaveEstate } from "./useEstates";
import { base_object } from "@/pages/Maintainers/Estates/estates.constants";

function normalizeCategoryValues(rawValue) {
	if (!rawValue) return [];
	if (Array.isArray(rawValue)) {
		return rawValue.map((item) => Number(item?.value ?? item)).filter((id) => !Number.isNaN(id));
	}
	return [];
}

export function useEstatesForm({ option, slug, onClose, filters }) {
	const isOpen = option === "crear" || option === "editar";
	const isEditMode = option === "editar";
	const modalTitle = useMemo(() => (isEditMode ? "Editar Bodega" : "Crear Bodega"), [isEditMode]);

	const { mutate: saveEstate, isLoading: isLoadingSave } = useSaveEstate();

	const canLoadDetail = isEditMode && !!slug;
	const { data: response, isLoading: isLoadingElement, isFetching: isFetchingElement } = useEstateDetail(slug, canLoadDetail);

	const [formState, setFormState] = useState({ ...base_object });
	const [formErrors, setFormErrors] = useState({});

	useEffect(() => {
		if (isEditMode && response?.data) {
			const detail = response.data;
			setFormState({
				slug: detail.slug ?? "",
				name: detail.name ?? "",
				estateParentID: detail.estate_parent_id ?? "",
				categoriesID: detail.categories_id ?? [],
				implemented: !!detail.implemented,
			});
		}
	}, [isEditMode, response]);

	useEffect(() => {
		if (!isOpen) {
			setFormState({ ...base_object });
			setFormErrors({});
		}
	}, [isOpen]);

	const validateForm = (state) => {
		const errors = {};
		if (!state.name?.trim()) errors.name = "Requerido";
		const categoryIds = normalizeCategoryValues(state.categoriesID);
		if (!categoryIds.length) errors.categoriesID = "Seleccione al menos un tipo de bodega";
		return errors;
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		const errors = validateForm(formState);
		setFormErrors(errors);
		if (Object.keys(errors).length) return;

		const categoryIds = normalizeCategoryValues(formState.categoriesID);
		const estateParentID = formState.estateParentID ? Number(formState.estateParentID) : null;

		const payload = {
			slug: formState.slug,
			name: formState.name?.trim() || "",
			categoriesID: categoryIds,
			implemented: formState.implemented,
		};

		if (estateParentID) {
			payload.estateParentID = estateParentID;
		}

		saveEstate(
			{ form: payload, filters },
			{
				onSuccess: () => {
					toast.success(isEditMode ? "Bodega actualizada correctamente" : "Bodega creada correctamente");
					onClose();
				},
				onError: (error) => {
					toast.error(error?.response?.data?.error || error?.response?.data?.message || "Error al guardar la bodega");
				},
			},
		);
	};

	return {
		isOpen,
		isEditMode,
		modalTitle,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		handleSubmit,
	};
}
